import React from "react";
import { SvgIcon, Tooltip, Typography, Box, useTheme } from "@mui/material"; // Import Tooltip, Typography, Box, useTheme
import { useUnits } from "../../contexts/UnitContext"; // Assuming this path is correct
import GlassTileLayout from "../layouts/GlassTileLayout"; // Adjust path as needed

// Scuba Fin Icon
const FinIcon = () => (
  <SvgIcon>
    <path d="M18,15V18A3,3 0 0,1 15,21H12V19H15A1,1 0 0,0 16,18V15L11,13V11L16,9V12L18,15M6,12V9L11,11V13L6,15V18A1,1 0 0,0 7,19H10V21H7A3,3 0 0,1 4,18V15L2,12L4,9V6A3,3 0 0,1 7,3H10V5H7A1,1 0 0,0 6,6V9L11,7V9L6,12Z" />
  </SvgIcon>
);

const SurfaceSwimDistanceTile = ({ surfaceSwimDistance }) => {
  const { unitSystem } = useUnits();
  const theme = useTheme(); // Use theme for potential styling in tooltip

  const formatDistance = (meters, targetUnitSystem) => {
    if (meters === null || meters === undefined) return "N/A";

    if (targetUnitSystem === "metric") {
      return `${meters}m`;
    } else {
      const feet = Math.round(meters * 3.28084);
      return `${feet}ft`;
    }
  };

  const formattedDistance = formatDistance(surfaceSwimDistance, unitSystem);

  const getTooltipContent = (meters) => {
    if (meters === null || meters === undefined) {
      return (
        <Typography variant="caption" color="inherit">
          Surface swim distance not available.
        </Typography>
      );
    }

    const metricValue = formatDistance(meters, "metric");
    const imperialValue = formatDistance(meters, "imperial");

    return (
      <React.Fragment>
        <Typography
          color="inherit"
          variant="subtitle2"
          sx={{ fontWeight: 600 }}
        >
          Surface Swim Distance
        </Typography>
        <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
          This is the estimated distance a diver might need to swim on the
          surface to reach the dive site from the entry point.
        </Typography>
        <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
          Currently displayed in{" "}
          {unitSystem === "metric" ? "metric" : "imperial"} units.
        </Typography>
        <Typography
          variant="caption"
          display="block"
          sx={{ mt: 0.5, fontStyle: "italic" }}
        >
          ({metricValue} / {imperialValue})
        </Typography>
      </React.Fragment>
    );
  };

  return (
    <Tooltip
      title={getTooltipContent(surfaceSwimDistance)}
      placement="top"
      arrow
      enterDelay={0} // Instant appearance on hover
      leaveDelay={100}
      enterTouchDelay={0} // Instant appearance on tap
    >
      {/* Box wrapper ensures the Tooltip has a direct, interactive DOM element */}
      <Box
        tabIndex={0}
        role="button"
        sx={{
          display: "block",
          width: "100%",
          height: "100%",
          cursor: "pointer",
        }}
      >
        <GlassTileLayout
          icon={FinIcon} // Pass the FinIcon component directly
          label="Surface Swim"
          value={formattedDistance}
          // You might want to adjust iconColor if you have a specific color for this icon
          // For instance, if you want it to be theme.palette.secondary.main:
          // iconColor={(theme) => theme.palette.secondary.main}
        />
      </Box>
    </Tooltip>
  );
};

export default SurfaceSwimDistanceTile;
